<template lang="pug">
.cp-about
  router-view
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
    }
  },
  computed: {},
  methods: {}
}
</script>
<style lang="stylus">
</style>
